import {inject, Injectable} from "@angular/core";
import {sinceOneDay} from "src/app/app.config";
import {NotificationApiClient} from "src/app/infrastructure/moovement-api/web-api/notification.api-client";
import {NotificationsStore} from "src/app/presentation/main-view/notifications/notifications.store";
import {Notification} from "src/app/infrastructure/moovement-api/models/notification";

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  private readonly notificationsStore = inject(NotificationsStore);
  private readonly notificationApiClient = inject(NotificationApiClient);

  loadNotifications(): void {
    this.notificationApiClient.getNotifications(sinceOneDay()).subscribe(notifications => this.notificationsStore.setAllEntities(notifications));
  }

  dismissNotification(notification: Notification): void {
    this.notificationApiClient.dismissNotification(notification).subscribe(() => this.notificationsStore.remove(notification.id));
  }
}
